import React from 'react';
import { Form, InputNumber, Select, Row, Col, Typography } from 'antd';

const { Title } = Typography;

const STAT_ROLES = [
  { label: 'Batter', value: 0 },
  { label: 'Bowler', value: 1 },
  { label: 'All-Rounder', value: 2 },
  { label: 'Wicket Keeper', value: 3 },
];

const helpStyle: React.CSSProperties = { color: '#999', fontSize: 12 };

export const BaseStatsFormSection: React.FC = () => {
  return (
    <>
      <Row gutter={16}>
        <Col xs={24} sm={8}>
          <Form.Item
            label="Role"
            name="baseStats_role"
            rules={[{ required: true }]}
            initialValue={0}
          >
            <Select options={STAT_ROLES} />
          </Form.Item>
        </Col>
      </Row>

      <Title level={5} style={{ fontSize: 14, marginBottom: 12 }}>
        Physical (PHY)
      </Title>
      <Row gutter={16}>
        <Col xs={24} sm={4}>
          <Form.Item
            label="Speed"
            name="baseStats_phySpeed"
            rules={[{ required: true }]}
            initialValue={5}
            help={<span style={helpStyle}>1 - 10</span>}
          >
            <InputNumber min={1} max={10} style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={4}>
          <Form.Item
            label="Stamina"
            name="baseStats_phyStamina"
            rules={[{ required: true }]}
            initialValue={5}
            help={<span style={helpStyle}>1 - 10</span>}
          >
            <InputNumber min={1} max={10} style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={4}>
          <Form.Item
            label="Power"
            name="baseStats_phyPower"
            rules={[{ required: true }]}
            initialValue={5}
            help={<span style={helpStyle}>1 - 10</span>}
          >
            <InputNumber min={1} max={10} style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={4}>
          <Form.Item
            label="Reflex"
            name="baseStats_phyReflex"
            rules={[{ required: true }]}
            initialValue={5}
            help={<span style={helpStyle}>1 - 10</span>}
          >
            <InputNumber min={1} max={10} style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={4}>
          <Form.Item
            label="Acrobatics"
            name="baseStats_phyAcrobatics"
            rules={[{ required: true }]}
            initialValue={5}
            help={<span style={helpStyle}>1 - 10</span>}
          >
            <InputNumber min={1} max={10} style={{ width: '100%' }} />
          </Form.Item>
        </Col>
      </Row>

      <Title level={5} style={{ fontSize: 14, marginBottom: 12 }}>
        Skill (SKL)
      </Title>
      <Row gutter={16}>
        <Col xs={24} sm={4}>
          <Form.Item
            label="Footwork"
            name="baseStats_sklFootwork"
            rules={[{ required: true }]}
            initialValue={7}
            help={<span style={helpStyle}>1 - 15</span>}
          >
            <InputNumber min={1} max={15} style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={4}>
          <Form.Item
            label="Timing"
            name="baseStats_sklTiming"
            rules={[{ required: true }]}
            initialValue={10}
            help={<span style={helpStyle}>1 - 20</span>}
          >
            <InputNumber min={1} max={20} style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={4}>
          <Form.Item
            label="Range"
            name="baseStats_sklRange"
            rules={[{ required: true }]}
            initialValue={5}
            help={<span style={helpStyle}>1 - 10</span>}
          >
            <InputNumber min={1} max={10} style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={4}>
          <Form.Item
            label="Bowling"
            name="baseStats_sklBowling"
            help={<span style={helpStyle}>1 - 10 (optional)</span>}
          >
            <InputNumber min={1} max={10} style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={4}>
          <Form.Item
            label="WK"
            name="baseStats_sklWk"
            help={<span style={helpStyle}>1 - 15 (optional)</span>}
          >
            <InputNumber min={1} max={15} style={{ width: '100%' }} />
          </Form.Item>
        </Col>
      </Row>

      <Title level={5} style={{ fontSize: 14, marginBottom: 12 }}>
        Accuracy (ACC) &amp; Composure
      </Title>
      <Row gutter={16}>
        <Col xs={24} sm={4}>
          <Form.Item
            label="Bat Acc"
            name="baseStats_accBat"
            help={<span style={helpStyle}>1 - 20 (optional)</span>}
          >
            <InputNumber min={1} max={20} style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={4}>
          <Form.Item
            label="Bowl Acc"
            name="baseStats_accBowl"
            help={<span style={helpStyle}>1 - 20 (optional)</span>}
          >
            <InputNumber min={1} max={20} style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={4}>
          <Form.Item
            label="Field Acc"
            name="baseStats_accField"
            help={<span style={helpStyle}>0 - 20 (optional)</span>}
          >
            <InputNumber min={0} max={20} step={0.5} style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={4}>
          <Form.Item
            label="Composure"
            name="baseStats_cmp"
            rules={[{ required: true }]}
            initialValue={5}
            help={<span style={helpStyle}>1 - 10</span>}
          >
            <InputNumber min={1} max={10} style={{ width: '100%' }} />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
